import { render, staticRenderFns } from "./codeMaster.vue?vue&type=template&id=c56339e2&"
import script from "./codeMaster.vue?vue&type=script&lang=js&"
export * from "./codeMaster.vue?vue&type=script&lang=js&"
import style0 from "./codeMaster.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports